import { Address } from "viem";
import TicketEntry from "../../../../miscellaneous/TicketEntry";
import FrequencyChart from "./FrequencyChart";
import { LotteryStatistics } from "../../../../../models/LotteryStatistics";

export interface NumberStatisticsProps {
  statistics: LotteryStatistics;
  latestDrawNumber: bigint;
  currentCharity?: Address;
}

export default function NumberStatistics(props: NumberStatisticsProps) {
  // change props.statistics.numberFrequency to random entries
  return (
    <div className="xl:w-[40%] lg:w-[50%] md:w-[60%] sm:w-[80%] w-[100%] flex flex-col sm:flex-row sm:m-0 m-4 sm:items-start items-center">
      <div className={`w-1/2 flex flex-col items-center`} data-aos="fade-right">
        <span className="font-koulen ~text-base/lg text-gray ~mb-0.5/1">
          NUMBER FREQUENCY
        </span>
        <FrequencyChart
          data={Array.from(
            props.statistics.numberFrequency,
            ([number, frequency]) => ({
              number: number.toString(),
              frequency: frequency,
            }),
          )}
          yLabel="Number"
        />
      </div>
      <div className="w-8"></div>
      <div className="w-1/2 flex flex-col items-center">
        <div
          className={`~mb-1/2 w-full flex flex-col items-center`}
          data-aos="fade-left"
        >
          <span className="font-koulen ~text-base/lg text-gray ~mb-0.5/1 ~mt-6/8 md:mt-0">
            STAR FREQUENCY
          </span>
          <FrequencyChart
            data={Array.from(
              props.statistics.starFrequency,
              ([number, frequency]) => ({
                number: number.toString(),
                frequency: frequency,
              }),
            )}
            yLabel="Lucky Star"
          />
        </div>
        <div
          className={`flex flex-col self-center items-center mt-2`}
          data-aos="fade-left"
        >
          <span className="font-koulen ~text-base/lg text-gray ~mt-2/3">
            MOST OVERDUE
          </span>
          <TicketEntry
            ticket={props.statistics.mostOverdueTicket}
            onTooltip={(number?: bigint, star?: bigint) => {
              if (number != undefined) {
                const draws: number =
                  Number(props.latestDrawNumber) -
                  (props.statistics.numberLastSeen.get(Number(number)) ?? 0);
                return `Number ${number} hasn't appeared in ${draws ?? 0} draw${draws != 1 ? "s" : ""}`;
              } else {
                const draws: number =
                  Number(props.latestDrawNumber) -
                  (props.statistics.starLastSeen.get(Number(star)) ?? 0);
                return `Star ${star} hasn't appeared in ${draws} draw${draws != 1 ? "s" : ""}`;
              }
            }}
          ></TicketEntry>
          <span className="font-koulen ~text-base/lg text-gray ~mt-2/3">
            MOST FREQUENT
          </span>
          <TicketEntry
            ticket={props.statistics.mostFrequentTicket}
            onTooltip={(number?: bigint, star?: bigint) => {
              if (number != undefined) {
                const count: number =
                  props.statistics.numberFrequency.get(Number(number)) ?? 0;
                return `Number ${number} was ${count < 1 ? "never drawn" : `drawn ${count} time${count > 1 ? "s" : ""}`}`;
              } else {
                const count: number =
                  props.statistics.starFrequency.get(Number(star)) ?? 0;
                return `Star ${star} was ${count < 1 ? "never drawn" : `drawn ${count} time${count > 1 ? "s" : ""}`}`;
              }
            }}
          ></TicketEntry>
          <span className="font-koulen ~text-base/lg text-gray ~mt-2/3">
            RARER
          </span>
          <TicketEntry
            ticket={props.statistics.leastFrequentTicket}
            onTooltip={(number?: bigint, star?: bigint) => {
              if (number != undefined) {
                const count: number =
                  props.statistics.numberFrequency.get(Number(number)) ?? 0;
                return `Number ${number} was ${count < 1 ? "never drawn" : `drawn only ${count} time${count > 1 ? "s" : ""}`}`;
              } else {
                const count: number =
                  props.statistics.starFrequency.get(Number(star)) ?? 0;
                return `Star ${star} was ${count < 1 ? "never drawn" : `drawn only ${count} time${count > 1 ? "s" : ""}`}`;
              }
            }}
          ></TicketEntry>
        </div>
      </div>
    </div>
  );
}
